import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { PartnersComponent } from './partners/partners.component';
import { PartnersDetailsComponent } from './partners-details/partners-details.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { NgbModule,NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgOtpInputModule } from  'ng-otp-input';
import {
  TranslateLoader,
  TranslateService,
  TranslateModule
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { GlobalErrorHandlerService } from './services/error-handler/global-error-handler.service';
import { FormsModule } from '@angular/forms';
import { HttpHeaderInterceptorService } from './services/http-interceptor/http-header-interceptor.service';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AboutComponent } from './about/about.component';
import { FaqComponent } from './faq/faq.component';
import { LocalStorageModule } from 'angular-2-local-storage-encrypt';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import { KycComponent } from './kyc/kyc.component';
import { CommonModule, DatePipe } from '@angular/common';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    PartnersComponent,
    PartnersDetailsComponent,
    NavbarComponent,
    FooterComponent,
    TermsConditionsComponent,
    TransactionsComponent,
    SidebarComponent,
    AboutComponent,
    FaqComponent,
    UpdateProfileComponent,
    KycComponent,
    ForgetPasswordComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    NgOtpInputModule,
    NgbPaginationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    LocalStorageModule.forRoot({
      prefix: 'my-app',
      storageType: 'localStorage',
      encryptionActive: true,
      encryptionOptions: {
          encryptionKey: 'keyForEncriptHere',
          encryptionIv: 'iVHere',
          encryptionSalt: 'saltHere'
      }
  }),
  ToastrModule.forRoot(),
  BrowserAnimationsModule
  ],
  providers: [
    TranslateService,
    DatePipe,


    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpHeaderInterceptorService,
    //   multi: true
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
